import React, { useEffect, useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { makeStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Calendar } from 'primereact/calendar';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Tooltip } from '@material-ui/core';
import {
  FaHeart,
  FaAngleDown,
  FaPlus,
  FaSpinner,
  FaTrash,
  FaFirstdraft,
  FaBan,
} from 'react-icons/fa';
import TextField from '@material-ui/core/TextField';
import { Dialog as DialogPrime } from 'primereact/dialog';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { isMobile } from 'react-device-detect';
import { Toast } from 'primereact/toast';
import CorpoRequisicao from 'views/NovaRequisicao/CorpoRequisicao';
import listaUnidadesDeMedida from '../../utils/listaUnidadesDeMedida';
import CabecalhoRequisicao from '../NovaRequisicao/CabecalhoRequisicao';
import { dominioBackend } from '../../config/database';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'assets/scss/prime-table.scss';
import 'assets/css/prime-table.css';
import 'assets/css/geral.css';
import 'assets/css/minhas-requisicoes.css';

export default function MinhasRequisicoes() {
  const profissional = JSON.parse(localStorage.getItem('profissional'));
  const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));
  const [listaRequisicoes, setListaRequisicoes] = useState([]);
  const [carregandoListaRequisicoes, setCarregandoListaRequisicoes] = useState(false);
  const [visualizaSalvarRascunho, setVisualizaSalvarRascunho] = useState(false);
  const [visualizaExcluirRascunho, setVisualizaExcluirRascunho] = useState(false);
  const [first, setFirst] = useState();
  const [abreFavoritar, setAbreFavoritar] = useState(false);
  const [abreNovaRequisicao, setAbreNovaRequisicao] = useState(false);
  const [abreExcluirRascunho, setAbreExcluirRascunho] = useState(false);
  const [requisicaoSelecionada, setRequisicaoSelecionada] = useState(null);
  const [idRequisicaoSelecionada, setIdRequisicaoSelecionada] = useState(0);
  const [incluindoRequisicao, setIncluindoRequisicao] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [descricaoFavorito, setDescricaoFavorito] = useState('');
  const [checkFavoritoRequisitante, setCheckFavoritoRequisitante] = useState(false);
  const [checkFavoritoCC, setCheckFavoritoCC] = useState(false);
  const [listaFavoritoRequisitante, setListaFavoritoRequisitante] = useState([]);
  const [listaFavoritoCentroCusto, setListaFavoritoCentroCusto] = useState([]);
  const [almoxarifadoSelecionado, setAlmoxarifadoSelecionado] = useState(null);
  const [centroCustoSelecionado, setCentroCustoSelecionado] = useState(null);
  const [almoxarifadoSelecionadoFiltro, setAlmoxarifadoSelecionadoFiltro] = useState(null);
  const [statusSelecionado, setStatusSelecionado] = useState(null);
  const [listaProdutosSelecionados, setListaProdutosSelecionados] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingRequisicao, setLoadingRequisicao] = useState(false);
  const [loadingRascunho, setLoadingRascunho] = useState(false);
  const [expandedRows, setExpandedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedDateInclusao, setSelectedDateInclusao] = useState(null);
  const [listaAlmoxarifados, setListaAlmoxarifados] = useState([]);
  const [listaStatus, setListaStatus] = useState([]);
  const [observacao, setObservacao] = useState('');
  const [ramal, setRamal] = useState('');
  const [setorRequisitante, setSetorRequisitante] = useState('');
  const [tipoRequisicao, setTipoRequisicao] = useState('');
  const [openMotivoRecusa, setOpenMotivoRecusa] = useState(false);
  const [rowSelecionado, setRowSelecionado] = useState(null);
  const dt = useRef(null);
  const toast = useRef(null);

  // useEffect(() => {
  //   const centralHCFamema = {
  //     id: 13,
  //     codigo: '00',
  //     nome: 'CENTRAL - HCFAMEMA',
  //     centroCusto: {
  //       id: 1054,
  //       codigo: '5.92.920',
  //       nome: 'Material',
  //     },
  //   };

  //   const produtos = [
  //     {
  //       idProduto: 14887,
  //       nome: 'ABOBRINHA BRASILEIRA EXTRA A',
  //       quantidadeRequisitada: 1,
  //       valor: 2.86,
  //       unidade: {
  //         valor: 'und',
  //         nome: 'Unidade',
  //       },
  //     },
  //     {
  //       idProduto: 15216,
  //       nome: 'ADOCANTE DIETETICO, COMPOSTO DE SUCRALOSE LIQUIDO',
  //       quantidadeRequisitada: 1,
  //       valor: 12,
  //       unidade: {
  //         valor: 'und',
  //         nome: 'Unidade',
  //       },
  //     },
  //   ];

  //   setListaProdutosSelecionados(produtos);
  //   setAbreNovaRequisicao(true);
  //   setAlmoxarifadoSelecionado(centralHCFamema);
  //   setRamal('1234');
  //   setSetorRequisitante('Enfermaria');
  //   setActiveStep(2);
  // }, []);

  const listaTipoRequisicoes = [
    {
      nome: 'Solicitação',
      valor: 'S',
    },
    {
      nome: 'Devolução',
      valor: 'D',
    },
  ];

  const useStyles = makeStyles(theme => ({
    autoComplete: {
      width: '20%',
      height: '40px',
      marginLeft: '8px',
      marginTop: '0px !important',
    },
  }));

  const classes = useStyles();

  const mostrarAviso = (titulo, mensagem, cor) => {
    toast.current.show({ severity: cor, summary: titulo, detail: mensagem, life: 3000 });
  };

  function atualizaListagemRequisicoes() {
    setCarregandoListaRequisicoes(true);
    dominioBackend
      .get(`/api/requisicaoRequisitante/${profissional.centroCustoProfissionalId}`)
      .then(
        res => {
          setListaRequisicoes(res.data);
          setCarregandoListaRequisicoes(false);
        },
        () => {
          setCarregandoListaRequisicoes(false);
        }
      );
  }

  function listarFavoritos() {
    dominioBackend
      .get(`/api/requisicoesFavoritasProfissional/${profissional.profissionalId}`)
      .then(res => {
        setListaFavoritoRequisitante(res.data);
      });

    dominioBackend
      .get(`/api/requisicoesFavoritasCentroCusto/${profissional.centroCustoProfissionalId}`)
      .then(res => {
        setListaFavoritoCentroCusto(res.data);
      });
  }

  function listarAlmoxarifados() {
    dominioBackend.get(`/api/almoxarifados`).then(res => {
      setListaAlmoxarifados(res.data);
    });
  }

  function listarStatus() {
    dominioBackend.get(`/api/status`).then(res => {
      setListaStatus(res.data.map(status => status.descricao));
    });
  }

  useEffect(() => {
    listarAlmoxarifados();
    listarStatus();
    atualizaListagemRequisicoes();
    listarFavoritos();
  }, []);

  useEffect(() => {
    if (idRequisicaoSelecionada > 0) {
      dominioBackend.get(`/api/requisicao/${idRequisicaoSelecionada}`).then(res => {
        setRequisicaoSelecionada(res.data);
      });
    }
  }, [idRequisicaoSelecionada]);

  function handleAlterarRascunho(rowData) {
    setIdRequisicaoSelecionada(rowData.id);

    dominioBackend.get(`/api/requisicao/${rowData.id}`).then(
      res => {
        const produtosConvertidos = res.data.produtos.map(p => {
          const unidadeObj = listaUnidadesDeMedida.find(u => u.valor === p.unidade);
          return {
            ...p,
            unidade: unidadeObj || null,
          };
        });
        setAlmoxarifadoSelecionado(res.data.almoxarifado);
        setListaProdutosSelecionados(produtosConvertidos);
        setLoadingRequisicao(false);
        setVisualizaSalvarRascunho(true);
        setVisualizaExcluirRascunho(true);
        setActiveStep(1);
        setIncluindoRequisicao(false);
        setAbreNovaRequisicao(true);
        setRamal(res.data.ramal);
        setObservacao(res.data.observacao);
        setSetorRequisitante(res.data.setorRequisitante);
        setTipoRequisicao(
          listaTipoRequisicoes.find(item => item.valor === res.data.tipoRequisicao)
        );
      },
      () => {
        mostrarAviso('Erro', 'Não foi possível recuperar o rascunho', 'error');
      }
    );
  }

  async function handleSalvarRascunho() {
    if (!tipoRequisicao) {
      mostrarAviso('Aviso', 'Preencha os dados antes de continuar', 'warn');
      return;
    }

    setLoadingRascunho(true);
    const idCentroCusto = profissional.centroCusto[0].id.toString();

    try {
      const dadosRequisicao = {
        idProfissionalRequisitante: profissional.profissionalId,
        idAlmoxarifado: almoxarifadoSelecionado.id,
        observacao,
        ramal,
        setorRequisitante,
        tipoRequisicao: tipoRequisicao?.valor ? tipoRequisicao?.valor : '',
        idCentroCusto,
      };

      if (!incluindoRequisicao) {
        await dominioBackend.delete(`api/excluirRequisicoesProdutos/${requisicaoSelecionada.id}`);
        await dominioBackend.put(
          `/api/alterarRascunho/${requisicaoSelecionada.id}`,
          dadosRequisicao
        );

        let dadosRequisicaoProduto = null;

        await Promise.all(
          listaProdutosSelecionados.map(async produto => {
            dadosRequisicaoProduto = {
              idRequisicao: requisicaoSelecionada.id,
              idProduto: produto.idProduto,
              quantidadeRequisitada: produto.quantidadeRequisitada,
              informacaoAdicional: produto.informacaoAdicional || null,
              valor: produto?.valor ?? 0,
              unidade: produto.unidade?.valor,
            };

            dominioBackend.post(`/api/rascunhoRequisicaoProduto`, dadosRequisicaoProduto);
          })
        );
        setActiveStep(0);
        setAlmoxarifadoSelecionado(null);
        setIncluindoRequisicao(false);
        setAbreNovaRequisicao(false);
        atualizaListagemRequisicoes();
        setLoadingRascunho(false);
        setRequisicaoSelecionada(null);
        setIdRequisicaoSelecionada(0);
        mostrarAviso('Sucesso', 'Rascunho salvo com sucesso', 'success');
      } else {
        const responseRascunho = await Promise.resolve(
          dominioBackend.post(`/api/requisitarRascunho`, dadosRequisicao)
        );

        let dadosRequisicaoProduto = null;
        /* chamado 2021080039 - add valor (saldoProduto) */
        await Promise.all(
          listaProdutosSelecionados.map(async produto => {
            dadosRequisicaoProduto = {
              idRequisicao: responseRascunho.data.id,
              idProduto: produto.idProduto,
              quantidadeRequisitada: produto.quantidadeRequisitada,
              informacaoAdicional: produto.informacaoAdicional || null,
              valor: produto?.valor ?? 0,
              unidade: produto.unidade?.valor,
            };
            dominioBackend.post(`/api/requisicaoProduto`, dadosRequisicaoProduto);
          })
        );
        setActiveStep(0);
        setAlmoxarifadoSelecionado(null);
        setIncluindoRequisicao(false);
        setAbreNovaRequisicao(false);
        atualizaListagemRequisicoes();
        setLoadingRascunho(false);
        mostrarAviso('Sucesso', 'Rascunho salvo com sucesso', 'success');
      }
    } catch (error) {
      mostrarAviso('Erro', `Erro ao salvar rascunho: ${error}`, 'error');
      setLoadingRascunho(false);
    }
  }

  function handleExcluirRascunho() {
    dominioBackend.delete(`/api/excluirRequisicao/${requisicaoSelecionada.id}`).then(
      () => {
        setActiveStep(0);
        setAlmoxarifadoSelecionado(null);
        setIncluindoRequisicao(false);
        setAbreNovaRequisicao(false);
        atualizaListagemRequisicoes();
        setAbreExcluirRascunho(false);
        setLoading(false);
        mostrarAviso('Sucesso', 'Rascunho excluído com sucesso', 'success');
      },
      () => {
        mostrarAviso('Erro', 'Não foi possível excluir o rascunho', 'error');
      }
    );
  }

  function handleAbrirFavoritar(rowData) {
    setIdRequisicaoSelecionada(rowData.id);
    setAbreFavoritar(true);
  }

  function handleFavoritar() {
    const idCentroCusto = profissional.centroCusto[0].id.toString();
    const dataFavoritar = {
      idProfissional: checkFavoritoRequisitante ? profissional.profissionalId : null,
      idRequisicao: idRequisicaoSelecionada,
      descricao: descricaoFavorito,
      idCentroCusto: checkFavoritoCC ? idCentroCusto : null,
    };

    dominioBackend.post('/api/favoritarRequisicao', dataFavoritar).then(
      () => {
        setCheckFavoritoCC(false);
        setCheckFavoritoRequisitante(false);
        setAbreFavoritar(false);
        mostrarAviso('Sucesso', 'Requisição favoritada com sucesso', 'success');
        listarFavoritos();
      },
      () => {
        mostrarAviso('Erro', 'Erro ao favoritar a requisição', 'error');
      }
    );
  }

  const clearInputs = () => {
    setObservacao('');
    setRamal('');
    setSetorRequisitante('');
    setTipoRequisicao('');
  };

  function handleFecharModal() {
    setActiveStep(0);
    setIncluindoRequisicao(false);
    setAbreNovaRequisicao(false);
    setRequisicaoSelecionada(null);
    setIdRequisicaoSelecionada(0);
    clearInputs();
  }

  async function handleRequisitar() {
    setLoading(true);

    try {
      const dadosRequisicao = {
        idProfissionalRequisitante: profissional.profissionalId,
        idAlmoxarifado: almoxarifadoSelecionado.id,
        observacao,
        ramal,
        setorRequisitante,
        tipoRequisicao: tipoRequisicao.valor,
        centroCusto: centroCustoSelecionado.id,
      };

      let idRequisicao = null;

      if (incluindoRequisicao) {
        const response = await dominioBackend.post(`/api/requisitar`, dadosRequisicao);
        idRequisicao = response.data.id;
      } else {
        await dominioBackend.delete(`/api/excluirRequisicoesProdutos/${requisicaoSelecionada.id}`);
        await dominioBackend.put(`/api/requisitar/${requisicaoSelecionada.id}`, dadosRequisicao);
        idRequisicao = requisicaoSelecionada.id;
      }

      // Adiciona os produtos
      await Promise.all(
        listaProdutosSelecionados.map(produto => {
          const dadosRequisicaoProduto = {
            idRequisicao,
            idProduto: produto.idProduto,
            quantidadeRequisitada: produto.quantidadeRequisitada,
            informacaoAdicional: produto.informacaoAdicional || null,
            valor: produto.valor ?? 0,
            unidade: produto.unidade.valor,
          };

          return dominioBackend.post(`/api/requisicaoProduto`, dadosRequisicaoProduto);
        })
      );

      // Exporta
      // await dominioBackend.get(`/api/exportarRequisicao/${idRequisicao}`);

      // Reset de estados
      setActiveStep(0);
      setAlmoxarifadoSelecionado(null);
      setIncluindoRequisicao(false);
      setAbreNovaRequisicao(false);
      setRequisicaoSelecionada(null);
      setIdRequisicaoSelecionada(0);

      atualizaListagemRequisicoes();
      mostrarAviso('Sucesso', 'Requisição incluída com sucesso', 'success');
    } catch (error) {
      mostrarAviso('Erro', `Erro ao incluir requisição: ${error}`, 'error');
    } finally {
      setLoading(false);
    }
  }

  function handleNovaRequisicao() {
    setAlmoxarifadoSelecionado(null);
    setListaProdutosSelecionados([]);
    setVisualizaSalvarRascunho(false);
    setVisualizaExcluirRascunho(false);
    setActiveStep(1);
    setIncluindoRequisicao(true);
    setAbreNovaRequisicao(true);
  }

  function handleNovaRequisicaoPorFavorita(id) {
    setIncluindoRequisicao(true);
    setAbreNovaRequisicao(true);
    setLoadingRequisicao(true);
    setVisualizaExcluirRascunho(false);
    setVisualizaSalvarRascunho(false);
    setActiveStep(1);
    setAnchorEl(false);
    dominioBackend.get(`/api/requisicaoFavorita/${profissional.profissionalId}/${id}`).then(res => {
      const produtosConvertidos = res.data.requisicoesProduto.map(p => {
        const unidadeObj = listaUnidadesDeMedida.find(u => u.valor === p.unidade);
        return {
          ...p,
          unidade: unidadeObj || null,
        };
      });

      setAlmoxarifadoSelecionado(res.data.almoxarifado);
      setListaProdutosSelecionados(produtosConvertidos);
      setLoadingRequisicao(false);
      setObservacao(res.data.observacao);
      setRamal(res.data.ramal);
      setSetorRequisitante(res.data.setorRequisitante);
      setTipoRequisicao(listaTipoRequisicoes.find(item => item.valor === res.data.tipoRequisicao));
    });
  }

  function handleNovaRequisicaoPorFavoritaCC(id) {
    setIncluindoRequisicao(true);
    setAbreNovaRequisicao(true);
    setLoadingRequisicao(true);
    setVisualizaExcluirRascunho(false);
    setVisualizaSalvarRascunho(false);
    setActiveStep(1);
    setAnchorEl(false);
    dominioBackend.get(`/api/requisicaoFavorita/${profissional.profissionalId}/${id}`).then(res => {
      const produtosConvertidos = res.data.requisicoesProduto.map(p => {
        const unidadeObj = listaUnidadesDeMedida.find(u => u.valor === p.unidade);
        return {
          ...p,
          unidade: unidadeObj || null,
        };
      });
      setAlmoxarifadoSelecionado(res.data.almoxarifado);
      setListaProdutosSelecionados(produtosConvertidos);
      setLoadingRequisicao(false);
      setObservacao(res.data.observacao);
    });
  }

  function handleClosePopMenuFavoritos() {
    setAnchorEl(null);
  }

  function handleExcluirFavorito(id) {
    dominioBackend.delete(`/api/excluirRequisicaoFavorita/${id}`).then(
      () => {
        mostrarAviso('Sucesso', 'Favorito excluído com sucesso', 'success');
        listarFavoritos();
      },
      () => {
        mostrarAviso('Erro', 'Não foi possível realizar a exclusão', 'error');
      }
    );
  }

  function getStepContent(step) {
    switch (step) {
      case 1:
        return (
          <CabecalhoRequisicao
            listaAlmoxarifados={listaAlmoxarifados}
            setAlmoxarifadoSelecionado={setAlmoxarifadoSelecionado}
            almoxarifadoSelecionado={almoxarifadoSelecionado}
            centroCustoSelecionado={centroCustoSelecionado}
            setCentroCustoSelecionado={setCentroCustoSelecionado}
            loadingRequisicao={loadingRequisicao}
          />
        );
      case 2:
        return (
          <CorpoRequisicao
            setListaProdutosSelecionados={setListaProdutosSelecionados}
            produtosSelecionados={listaProdutosSelecionados}
            exibirInformacaoAdicionalProduto={
              almoxarifadoSelecionado?.exibir_informacao_adicional_produto === true
            }
          />
        );
      default:
        return <></>;
    }
  }

  function dataBodyTemplate(rowData) {
    return (
      <>
        <span className="p-column-title">Data</span>
        <span>{new Date(rowData.pedidoEm).toLocaleDateString()}</span>
      </>
    );
  }

  function requisicaoBodyTemplate(rowData) {
    return (
      <>
        <span className="p-column-title">Nº Requisição</span>
        <span>{rowData.numero}</span>
      </>
    );
  }

  function almoxarifadoBodyTemplate(rowData) {
    return (
      <>
        <span className="p-column-title">Almoxarifado</span>
        <span>{rowData.almoxarifado}</span>
      </>
    );
  }

  function statusBodyTemplate(rowData) {
    return (
      <>
        <span className="p-column-title">Status</span>
        <span>{rowData.status}</span>
      </>
    );
  }

  function acoesBodyTemplate(rowData) {
    return (
      <div className="div-acoes">
        <span className="p-column-title">Ações</span>
        {rowData.statusId === configuracoes.statusRecusado ? (
          <Tooltip title="Motivo de recusa">
            <IconButton
              onClick={() => {
                setOpenMotivoRecusa(true);
                setRowSelecionado(rowData);
              }}
              style={{
                display: 'inherit',
                backgroundColor: 'red',
              }}
              className={`botao-alinhado-esquerda ${
                rowData.statusId !== configuracoes.statusRecusado ? 'invisivel' : null
              }`}
            >
              <FaBan color="white" size={18} />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Favoritar requisição">
            <IconButton
              onClick={() => handleAbrirFavoritar(rowData)}
              style={{
                display: 'inherit',
                backgroundColor: 'red',
              }}
            >
              <FaHeart color="white" size={14} />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Alterar Rascunho">
          <IconButton
            onClick={() => handleAlterarRascunho(rowData)}
            style={{
              display: rowData.statusId === configuracoes.statusRascunho ? 'inherit' : 'none',
              backgroundColor: 'black',
            }}
          >
            <FaFirstdraft color="white" size={14} />
          </IconButton>
        </Tooltip>
      </div>
    );
  }

  const header = (
    <>
      <div className="table-header campo-filtro">
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            onInput={e => setGlobalFilter(e.target.value)}
            placeholder="Pesquise pela descrição dos campos..."
            style={{ width: '78vw', height: '6vh' }}
          />
        </span>
      </div>
    </>
  );

  const pt = {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
    dayNamesMin: ['DO', 'SE', 'TE', 'QA', 'QI', 'SX', 'SA'],
    monthNames: [
      'janeiro',
      'fevereiro',
      'março',
      'abril',
      'maio',
      'junho',
      'julho',
      'agosto',
      'setembro',
      'outubro',
      'novembro',
      'dezembro',
    ],
    monthNamesShort: [
      'jan',
      'fev',
      'mar',
      'abr',
      'mai',
      'jun',
      'jul',
      'ago',
      'set',
      'out',
      'nov',
      'dez',
    ],
    today: 'Hoje',
    clear: 'Limpar',
    dateFormat: 'dd/mm/yy',
    weekHeader: 'Sm',
  };

  const dateInclusaoFilter = (
    <Calendar
      locale={pt}
      value={selectedDateInclusao}
      onChange={e => {
        setSelectedDateInclusao(e.value);
        if (e.value === null) {
          dt.current.filter(null, 'pedidoEm', 'notEquals');
          return;
        }
        dt.current.filter(
          new Date(e.value).toISOString().substring(0, 10),
          'pedidoEm',
          'startsWith'
        );
      }}
      dateFormat="dd/mm/yy"
      className="p-column-filter"
      placeholder="Data"
      showButtonBar
    />
  );

  const formatDate = date => {
    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month < 10) {
      month = `0${month}`;
    }

    if (day < 10) {
      day = `0${day}`;
    }

    return `${date.getFullYear()}-${month}-${day}`;
  };

  const filterDate = (value, filter) => {
    if (
      filter === undefined ||
      filter === null ||
      (typeof filter === 'string' && filter.trim() === '')
    ) {
      return true;
    }

    if (value === undefined || value === null) {
      return false;
    }

    return value === formatDate(filter);
  };

  const codigoBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Código</span>
        <span>{rowData.codigo}</span>
      </>
    );
  };

  const nomeBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Nome</span>
        <span>
          {rowData.nome}
          {rowData.informacaoAdicional && ` - ${rowData.informacaoAdicional.toUpperCase()}`}
        </span>
      </>
    );
  };

  const qtdBodyTemplate = rowData => {
    return (
      <>
        <span className="p-column-title">Quantidade Pedida</span>
        <span>
          {rowData.quantidadeRequisitada} 
{' '}
{rowData.unidade ? rowData.unidade : 'un'}
        </span>
      </>
    );
  };

  const almoxarifadoFilter = (
    <Autocomplete
      options={listaAlmoxarifados}
      getOptionLabel={option => `${option ? option.nome : null}`}
      onChange={(e, value) => {
        setAlmoxarifadoSelecionadoFiltro(value);
        dt.current.filter(value ? value.nome : null, 'almoxarifado', 'equals');
      }}
      value={almoxarifadoSelecionadoFiltro}
      filterSelectedOptions
      renderInput={params => <TextField {...params} label="Almoxarifado" variant="outlined" />}
    />
  );

  const statusFilter = (
    <Autocomplete
      options={listaStatus}
      getOptionLabel={option => `${option}`}
      onChange={(e, value) => {
        setStatusSelecionado(value);
        dt.current.filter(value, 'status', 'equals');
      }}
      value={statusSelecionado}
      filterSelectedOptions
      renderInput={params => <TextField {...params} label="Status" variant="outlined" />}
    />
  );

  const rowExpansionTemplate = data => {
    return (
      <div className="datatable">
        <div style={{ display: 'flex' }}>
          <h5>{data.numero ? `Requisição Nº ${data.numero}` : 'Requisição Nº:'}</h5>
          <h5 style={{ marginLeft: 32 }}>
            {data.tipoRequisicao === 'S'
              ? 'Tipo Req.: Solicitação'
              : data.tipoRequisicao === 'D'
              ? 'Tipo Req.: Devolução'
              : 'Tipo Req.: Não informado'}
          </h5>
          <h5 style={{ marginLeft: 32 }}>
            {data.ramal ? `Ramal: ${data.ramal}` : 'Ramal: Não informado'}
          </h5>
        </div>
        <h5>
          {data.setorRequisitante
            ? `Setor Requisitante: ${data.setorRequisitante}`
            : 'Setor Requisitante: Não informado'}
        </h5>
        <h5>{data.observacao ? `Obs: ${data.observacao}` : 'Observação: Não informado'}</h5>
        <DataTable value={data.produtos} rows={5} paginator className="p-datatable-prime">
          <Column field="codigo" body={codigoBodyTemplate} header="Código" sortable />
          <Column field="nome" body={nomeBodyTemplate} header="Nome" sortable />
          <Column
            field="quantidadeRequisitada"
            body={qtdBodyTemplate}
            header="Quantidade Pedida"
            sortable
          />
        </DataTable>
      </div>
    );
  };

  function textoBotaoRequisitar() {
    if (activeStep === 1) {
      return 'Prosseguir';
    }
    if (loading) {
      return <FaSpinner className="loading" />;
    }

    if (loadingRascunho) {
      return <FaSpinner className="loading" />;
    }

    return 'Requisitar';
  }

  function textoBotaoRascunho() {
    if (loadingRascunho) {
      return <FaSpinner className="loading" />;
    }

    return 'Salvar Rascunho';
  }

  return (
    <div id="goku">
      <Toast ref={toast} position="top-right" />
      <DialogPrime
        header="Excluir rascunho"
        visible={abreExcluirRascunho}
        onHide={() => setAbreExcluirRascunho(false)}
      >
        <p>Deseja realmente excluir o rascunho?</p>
        <Button
          variant="contained"
          size="large"
          style={{
            float: 'right',
          }}
          onClick={() => setAbreExcluirRascunho(false)}
        >
          Não
        </Button>
        <Button
          variant="contained"
          color="secondary"
          size="large"
          style={{
            float: 'right',
            marginRight: '10px',
          }}
          onClick={() => handleExcluirRascunho()}
        >
          {loading ? <FaSpinner className="loading" color="white" size={14} /> : <>Sim</>}
        </Button>
      </DialogPrime>

      <DialogPrime
        header="Favoritar requisição"
        visible={abreFavoritar}
        style={{ width: '65vw' }}
        onHide={() => setAbreFavoritar(false)}
      >
        <div>
          <TextField
            style={{ marginBottom: '20px', marginTop: '10px' }}
            id="descFavoritar"
            label="Descrição"
            variant="outlined"
            fullWidth
            onChange={e => setDescricaoFavorito(e.target.value)}
          />
          <div style={{ marginBottom: '20px' }}>
            <FormControlLabel
              control={(
                <Checkbox
                  name="checkedA"
                  checked={checkFavoritoRequisitante}
                  onChange={e => setCheckFavoritoRequisitante(e.target.checked)}
                />
              )}
              label="Para meu usuário"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  name="checkedB"
                  checked={checkFavoritoCC}
                  onChange={e => setCheckFavoritoCC(e.target.checked)}
                />
              )}
              label="Para meu Centro de Custo"
            />
          </div>
          <div style={{ float: 'right' }}>
            <Button
              variant="contained"
              color="primary"
              disabled={
                (!checkFavoritoRequisitante && !checkFavoritoCC) || descricaoFavorito.length === 0
              }
              onClick={() => handleFavoritar()}
            >
              Favoritar
            </Button>
          </div>
        </div>
      </DialogPrime>

      <DialogPrime
        header="Nova requisição"
        visible={abreNovaRequisicao}
        style={{ width: '65vw' }}
        onHide={() => handleFecharModal()}
      >
        {getStepContent(activeStep)}
        {activeStep !== 1 && (
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '24px' }}>
            <InputTextarea
              type="text"
              maxLength={200}
              defaultValue={observacao}
              onInput={e => setObservacao(e.target.value)}
              placeholder="Observação"
              style={{ width: '100%', height: '80px', marginBottom: '12px' }}
            />

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <InputText
                keyfilter="int"
                maxLength={11}
                value={ramal}
                onChange={e => {
                  // Remove tudo que não for dígito
                  const onlyNumbers = e.target.value.replace(/\D/g, '');
                  setRamal(onlyNumbers);
                }}
                placeholder="Ramal*"
                style={{ width: '20%', height: '40px' }}
              />

              <InputText
                type="text"
                maxLength={50}
                defaultValue={setorRequisitante}
                onInput={e => setSetorRequisitante(e.target.value)}
                placeholder="Setor Requisitante*"
                style={{ width: '40%', height: '40px', marginLeft: '8px' }}
              />

              <Autocomplete
                id="tipoRequisicao"
                options={listaTipoRequisicoes}
                getOptionLabel={option => option.nome}
                className={classes.autoComplete}
                value={tipoRequisicao}
                onChange={(e, value) => setTipoRequisicao(value)}
                renderInput={params => (
                  <TextField {...params} required label="Tipo Req." variant="outlined" />
                )}
              />
            </div>
          </div>
        )}
        <div style={{ width: '100%', marginBottom: 64 }}>
          <Button
            variant="contained"
            color="default"
            className={`${!visualizaSalvarRascunho ? 'invisivel' : null}`}
            style={{ float: 'left' }}
            onClick={() => handleSalvarRascunho()}
          >
            {textoBotaoRascunho()}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            className={`${!visualizaExcluirRascunho ? 'invisivel' : null}`}
            style={{ marginLeft: '10px' }}
            onClick={() => setAbreExcluirRascunho(true)}
          >
            Excluir Rascunho
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            style={{ float: 'right', marginLeft: '8px' }}
            onClick={() => {
              if (activeStep === 1) {
                if (almoxarifadoSelecionado && centroCustoSelecionado) {
                  setActiveStep(activeStep + 1);
                  if (incluindoRequisicao) {
                    setVisualizaSalvarRascunho(true);
                  } else if (
                    requisicaoSelecionada &&
                    requisicaoSelecionada.status.id === configuracoes.statusRascunho
                  ) {
                    setVisualizaExcluirRascunho(true);
                  }
                } else {
                  mostrarAviso('Aviso', 'Selecione os dados antes de continuar', 'warn');
                }
              } else if (activeStep === 2) {
                if (listaProdutosSelecionados?.length === 0) {
                  mostrarAviso('Aviso', 'Selecione um produto antes de continuar', 'warn');
                } else if (
                  ramal?.length === 0 ||
                  setorRequisitante?.length === 0 ||
                  tipoRequisicao?.length === 0
                ) {
                  mostrarAviso('Aviso', 'Preencha os campos obrigatórios', 'warn');
                } else {
                  handleRequisitar();
                }
              }
            }}
          >
            {textoBotaoRequisitar()}
          </Button>
        </div>
      </DialogPrime>

      <DialogPrime
        header="MOTIVO DE RECUSA"
        visible={openMotivoRecusa}
        style={{ width: '50vw' }}
        onHide={() => setOpenMotivoRecusa(false)}
      >
        <p style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
          {rowSelecionado?.motivoRecusa}
        </p>
      </DialogPrime>

      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={12}>
          <br />
          <Card>
            <CardHeader color="primary" id="minhasRequisicoes">
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <p className="card-title">
                    <strong>Minhas Requisições</strong>
                  </p>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    aria-controls="menu-favoritos"
                    aria-haspopup="true"
                    style={{
                      float: 'right',
                      backgroundColor: 'white',
                      borderTopLeftRadius: '0px',
                      borderBottomLeftRadius: '0px',
                    }}
                    className="botao-favoritos"
                    onClick={e => setAnchorEl(e.currentTarget)}
                  >
                    <FaAngleDown color="#8e24aa" size={24} />
                  </Button>
                  <Button
                    style={{
                      float: 'right',
                      backgroundColor: 'white',
                      color: '#8e24aa',
                      borderTopRightRadius: '0px',
                      borderBottomRightRadius: '0px',
                    }}
                    className="botao-nova-requisicao"
                    startIcon={<FaPlus color="#8e24aa" size={22} />}
                    onClick={() => handleNovaRequisicao()}
                  >
                    Novo
                  </Button>
                  <Menu
                    id="menu-favoritos"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClosePopMenuFavoritos}
                    MenuListProps={{ style: { width: isMobile ? '60vw' : '20vw' } }}
                  >
                    {listaFavoritoRequisitante.length > 0 ? (
                      <div>
                        <span className="menu-header">
                          <strong>Minhas favoritas</strong>
                        </span>
                        {listaFavoritoRequisitante.map(fav => (
                          <div key={fav.id} className="div-menu-favoritos">
                            <MenuItem
                              style={{ borderBottom: 'solid #e7e7e7 1px' }}
                              key={fav.id}
                              onClick={() => handleNovaRequisicaoPorFavorita(fav.id)}
                            >
                              {fav.descricao}
                            </MenuItem>
                            <Tooltip title="Excluir favorito">
                              <IconButton
                                onClick={() => handleExcluirFavorito(fav.id)}
                                style={{
                                  display: 'inherit',
                                  backgroundColor: 'transparent',
                                }}
                              >
                                <FaTrash color="black" size={14} />
                              </IconButton>
                            </Tooltip>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div style={{ marginLeft: '5px' }}>Sem registros de favoritos</div>
                    )}
                    {listaFavoritoCentroCusto.length > 0 ? (
                      <div>
                        <span className="menu-header">
                          <strong>C.C</strong>
                        </span>
                        {listaFavoritoCentroCusto.map(fav => (
                          <div key={fav.id} className="div-menu-favoritos">
                            <MenuItem
                              style={{ borderBottom: 'solid #e7e7e7 1px' }}
                              key={fav.id}
                              onClick={() => handleNovaRequisicaoPorFavoritaCC(fav.id)}
                            >
                              {fav.descricao}
                            </MenuItem>
                            <Tooltip title="Excluir favorito">
                              <IconButton
                                onClick={() => handleExcluirFavorito(fav.id)}
                                style={{
                                  display: 'inherit',
                                  backgroundColor: 'transparent',
                                }}
                              >
                                <FaTrash color="black" size={14} />
                              </IconButton>
                            </Tooltip>
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </Menu>
                </Grid>
              </Grid>
            </CardHeader>
            <CardBody className="card-body-0-padding">
              <div className="datatable">
                <div className="card">
                  <DataTable
                    ref={dt}
                    value={listaRequisicoes}
                    paginator
                    expandedRows={expandedRows}
                    onRowToggle={e => setExpandedRows(e.data)}
                    rowExpansionTemplate={rowExpansionTemplate}
                    rows={10}
                    header={header}
                    globalFilter={globalFilter}
                    emptyMessage="Sem requisições"
                    loading={carregandoListaRequisicoes}
                    first={first}
                    className="p-datatable-prime"
                    onPage={e => {
                      setFirst(e.first);
                      document.location.href = `${document.location.href.replace(
                        '#minhasRequisicoes',
                        ''
                      )}#minhasRequisicoes`;
                    }}
                    sortField="pedidoEm"
                    sortOrder={-1}
                  >
                    <Column expander style={{ width: '3em' }} />
                    <Column
                      field="numero"
                      header="Código da Requisição"
                      sortable
                      filter
                      filterPlaceholder="Código"
                      filterMatchMode="contains"
                      body={requisicaoBodyTemplate}
                      headerStyle={{ width: '11vw' }}
                    />
                    <Column
                      field="pedidoEm"
                      header="Data da Requisição"
                      sortable
                      filter
                      body={dataBodyTemplate}
                      filterElement={dateInclusaoFilter}
                      filterFunction={() => filterDate()}
                    />
                    <Column
                      field="almoxarifado"
                      header="Almoxarifado"
                      sortable
                      filter
                      filterElement={almoxarifadoFilter}
                      body={almoxarifadoBodyTemplate}
                    />
                    <Column
                      field="status"
                      header="Status"
                      sortable
                      filter
                      filterElement={statusFilter}
                      body={statusBodyTemplate}
                      headerStyle={{ width: '8vw' }}
                    />
                    <Column
                      field="acoes"
                      header="Ações"
                      body={acoesBodyTemplate}
                      headerStyle={{ width: '9vw' }}
                    />
                  </DataTable>
                </div>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
